import { object, string } from "yup";
import { Fragments } from "requests";

export const getValidation = (initialValues: Fragments.StoredTPLO) => {
  const validationSchema = object().shape({
    d1: string()
      .default("")
      .nullable(),
    d2: string()
      .default("")
      .nullable(),
    d3: string()
      .default("")
      .nullable(),
    rotationNeeded: string()
      .default("")
      .nullable(),
    initialTpa: string()
      .default("")
      .nullable(),
    postOpTpa: string()
      .default("")
      .nullable(),
    tploBladeSize: string()
      .default("")
      .nullable(),
    tploPlateSizeAndModel: string()
      .default("")
      .nullable()
  });

  return {
    validationSchema,
    defaultValues: validationSchema.cast(initialValues || {})
  };
};
